import React from 'react';
import { ChatAssistant, ASSISTANT_MODES } from '../chat-platform';

export default function ChatAssistantDemo() {
    return (
        <div className="min-h-screen bg-gray-50 text-gray-900">
            <div className="max-w-3xl mx-auto px-6 py-12 space-y-6">
                <article className="space-y-4">
                    <h1 className="text-3xl font-bold">Context Engineering</h1>
                    <p className="text-gray-700 leading-relaxed">
                        Trang nội dung giả lập. Mọi phần điều khiển của trợ lý (header, mode switcher,
                        close) đều nằm bên trong assistant — page chỉ chứa nội dung.
                    </p>
                    <p className="text-gray-700 leading-relaxed">
                        Bấm nút tròn ở góc phải dưới để mở trợ lý. Trong trợ lý, dùng menu góc để chuyển
                        giữa Floating / Sidebar / Full screen.
                    </p>
                </article>

                <section className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {Array.from({ length: 6 }).map((_, i) => (
                        <div key={i} className="bg-white border rounded-lg p-5 shadow-sm">
                            <div className="text-sm font-medium">Card #{i + 1}</div>
                            <div className="text-xs text-gray-500 mt-1">
                                Nội dung mẫu để test overlay / responsive của assistant.
                            </div>
                        </div>
                    ))}
                </section>

                <section className="bg-white border rounded-lg p-6 shadow-sm">
                    <h2 className="text-lg font-medium">Lorem ipsum</h2>
                    <p className="text-gray-600 mt-2 leading-relaxed">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor
                        incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
                        exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    </p>
                    <p className="text-gray-600 mt-3 leading-relaxed">
                        Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu
                        fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                        culpa qui officia deserunt mollit anim id est laborum.
                    </p>
                </section>
            </div>

            <ChatAssistant title="Simplize Assistant" defaultMode={ASSISTANT_MODES.SIDEBAR} defaultOpen />
        </div>
    );
}
